import { useEffect } from "react";
import moment from "moment";
import style from "./pagination.module.css";
import { Col, Form, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faChevronDown,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useState } from "react";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

export default function PlatformTable({
  showPageSizePicker = true,
  isAllowMultiSelect = false,
  tableColumnMappings,
  dataSource,
  pageSize,
  setPageSize,
  totalPage,
  page,
  totalRows,
  previous,
  next,
}) {
  // confirmation modal
  const [showConfimrationModal, setShowConfirmationModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmButtonText, setConfirmButtonText] = useState("false");

  const [triggeredActionData, setTriggeredActionData] = useState(null);
  const pageSizes = [10, 20, 50, 100];

  const pageSizeDropdownPopover = (
    <Popover id="page-size-my-circles-dropdown-popover" className="shadow">
      <Popover.Body className="d-flex flex-column p-2">
        <ul className={`action-menu-list`}>
          {pageSizes.map((size, key) => (
            <li
              key={key.toString()}
              onClick={(e) => setPageSize(size)}
              className={`${+pageSize === +size ? "active" : ""}`}
            >
              {size}
            </li>
          ))}
        </ul>
      </Popover.Body>
    </Popover>
  );

  const actionConfirmed = () => {
    if (triggeredActionData) {
      if (triggeredActionData.action.functionRef) {
        document.body.click();
        triggeredActionData.action.functionRef(triggeredActionData?.value);
        setTriggeredActionData(null);
      }
    }
  };

  const triggerActionFunction = (action, value) => {
    document.body.click();
    if (!action.confirmAction) {
      if (action.functionRef) {
        action.functionRef(value);
      }
    } else {
      setTriggeredActionData({ action, value });
      setConfirmText(action.confirmActionText || "");
      setConfirmButtonText(action.confirmButtonText || "");
      setShowConfirmationModal(true);
    }
  };

  useEffect(() => {}, [pageSize]);
  return (
    <>
      <div className="d-flex flex-column flex-grow-1 px-2">
        <div className="d-flex flex-column flex-grow-1">
          <div className="d-flex justify-content-end mb-2">
            <Col md={9} className="d-flex">
              {/* bluk selection checkbox */}
              {/* {bulkSelection && bulkSelection.length > 0 ? (
                <div className={`d-flex align-items-center `}>
                  {bulkActions}
                </div>
              ) : null} */}
            </Col>
            {/* sort by 10,20,50,... */}
            {showPageSizePicker ? (
              <Col
                md={3}
                className="d-flex justify-content-end align-items-center p-2"
              >
                <span className="me-2">Sort by:</span>
                <div
                  className={`custom-dropdown-wrapper d-flex justify-content-between align-items-center ${style.tableSort}`}
                >
                  <span className="font-size-16 text-accent-3">{pageSize}</span>
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom-end"
                    overlay={pageSizeDropdownPopover}
                    rootClose
                  >
                    <button className="no-style-btn p-0">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </button>
                  </OverlayTrigger>
                </div>
              </Col>
            ) : null}
          </div>
          <Table className={`platform-table mt-2`} responsive>
            {tableColumnMappings && tableColumnMappings.length > 0 ? (
              <>
                <thead>
                  <tr>
                    {isAllowMultiSelect ? <th></th> : null}
                    {tableColumnMappings.map((tableColumn, index) => (
                      <th
                        className="font-size-20 text-accent-2 fw-semi-bold"
                        key={index.toString()}
                      >
                        {tableColumn.column}

                        {/* sortable */}
                        {/* {tableColumn.isSortable && tableColumn.dataColumn ? (
                          <Sortable
                            sortTriggered={(shortState) =>
                              triggerSortAction(
                                shortState,
                                tableColumn.dataColumn
                                  ? tableColumn.dataColumn
                                  : ""
                              )
                            }
                          />
                        ) : null} */}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dataSource &&
                    dataSource.map((data, index) => (
                      <tr key={index.toString()}>
                        {/* checkbox for selection */}

                        {isAllowMultiSelect ? (
                          <td width={"5%"}>
                            <Form.Check type="checkbox">
                              <Form.Check.Input
                                type="checkbox"
                                // checked={bulkSelection.includes(data.id)}
                                // onChange={(e) =>
                                //   addOrRemoveFromSelection(
                                //     e.target.checked,
                                //     data.id
                                //   )
                                // }
                              />
                              <Form.Check.Label className="font-size-16"></Form.Check.Label>
                            </Form.Check>
                          </td>
                        ) : null}
                        {tableColumnMappings.map((tableColumn, columnIndex) => (
                          <td
                            key={columnIndex.toString()}
                            width={
                              tableColumn.isIndex || tableColumn.isAction
                                ? "5%"
                                : ""
                            }
                          >
                            {/* index */}
                            {tableColumn.isIndex
                              ? index + 1 + pageSize * page
                              : null}

                            {/* trigger action */}
                            {tableColumn.dataColumn &&
                            tableColumn.triggerFunction ? (
                              <span
                                className="cursor-pointer"
                                onClick={() =>
                                  tableColumn.triggerFunction
                                    ? tableColumn.triggerFunction(data.id)
                                    : null
                                }
                              >
                                {data[tableColumn.dataColumn]}
                              </span>
                            ) : null}

                            {/* regular columns */}
                            {tableColumn.dataColumn &&
                            !tableColumn.isUnixDate &&
                            !tableColumn.triggerFunction &&
                            !tableColumn.isPhoneNumber &&
                            !tableColumn.isDateTime &&
                            !tableColumn.isAssignedUserColumn
                              ? data[tableColumn.dataColumn]
                              : null}

                            {/* phone number with formatting */}
                            {/* {tableColumn.dataColumn && tableColumn.isPhoneNumber
                              ? formatPhoneNumber(data[tableColumn.dataColumn])
                              : null} */}

                            {/* unix date with format */}
                            {tableColumn.dataColumn && tableColumn.isUnixDate
                              ? moment
                                  .unix(data[tableColumn.dataColumn])
                                  .format(tableColumn.dateFormat || "LLL")
                              : null}

                            {/* normal date with format */}
                            {tableColumn.dataColumn &&
                            tableColumn.isDateTime &&
                            data[tableColumn.dataColumn] !== null
                              ? moment(data[tableColumn.dataColumn]).format(
                                  tableColumn.dateFormat || "ll"
                                )
                              : null}
                            {/* actions */}
                            {tableColumn.isAction && tableColumn.actions ? (
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom-end"
                                overlay={
                                  <Popover
                                    id="circle-actions"
                                    className="ms-4 shadow"
                                  >
                                    <Popover.Body className="d-flex flex-column p-2">
                                      <ul className={`action-menu-list `}>
                                        {tableColumn.actions.map(
                                          (action, actionIndex) => (
                                            <>
                                              {action.actionType === "url" &&
                                              action.url ? (
                                                <Link
                                                  className="text-decoration-none"
                                                  rel="noreferrer"
                                                  to={`${action.url}/${data.id}`}
                                                  key={actionIndex.toString()}
                                                >
                                                  <li key={`edit-circle`}>
                                                    {action.text}
                                                  </li>
                                                </Link>
                                              ) : null}
                                              {action.actionType === "url" &&
                                              action.dataColumn ? (
                                                <a
                                                  href={`${
                                                    data[action.dataColumn]
                                                  }`}
                                                  className="text-decoration-none"
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  key={actionIndex.toString()}
                                                >
                                                  <li key={`edit-circle`}>
                                                    {action.text}
                                                  </li>
                                                </a>
                                              ) : null}
                                              {action.actionType ===
                                                "function" &&
                                              action.functionRef ? (
                                                <li
                                                  key={actionIndex.toString()}
                                                  onClick={() =>
                                                    triggerActionFunction(
                                                      action,
                                                      data
                                                    )
                                                  }
                                                >
                                                  {action.text}
                                                </li>
                                              ) : null}
                                            </>
                                          )
                                        )}
                                      </ul>
                                    </Popover.Body>
                                  </Popover>
                                }
                                rootClose
                              >
                                <button className={`${style.tableAction}`}>
                                  <FontAwesomeIcon icon={faEllipsisV} />
                                </button>
                              </OverlayTrigger>
                            ) : null}
                          </td>
                        ))}
                      </tr>
                    ))}
                  {dataSource && dataSource.length === 0 ? (
                    <tr>
                      <td>{"no record found"}</td>
                    </tr>
                  ) : null}
                </tbody>
              </>
            ) : null}
          </Table>
        </div>
        {totalPage > 0 ? (
          <div className="d-flex justify-content-between p-2">
            <Col
              md={5}
              className="d-flex justify-content-center justify-content-sm-start align-items-center"
            >
              <span>
                Showing {page + 1} of {totalPage}
              </span>
            </Col>
            <Col
              className="d-flex justify-content-center justify-content-sm-start align-items-center"
              md={7}
            >
              <span>
                {pageSize * page + 1}-{dataSource.length + pageSize * page} of
                {totalRows}
              </span>
              <div
                className={`ms-2 ${style.paginatorBtn} ${
                  page === 0 ? `${style.disabled}` : ""
                }`}
                onClick={() => previous()}
              >
                <FontAwesomeIcon icon={faAngleLeft} />
              </div>
              <div
                className={`ms-2 ${style.paginatorBtn} ${
                  page + 1 === totalPage ? `${style.disabled}` : ""
                }`}
                onClick={() => next()}
              >
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </Col>
          </div>
        ) : null}
      </div>
      <ConfirmationModal
        showModal={showConfimrationModal}
        setModalState={(e) => setShowConfirmationModal(e)}
        title={`Confirm`}
        description={confirmText}
        confirmed={actionConfirmed}
        confirmButtonText={confirmButtonText}
      />
    </>
  );
}
